import Footer from "@/components/layout/Footer";
import Header from "@/components/layout/Header";
import { NotificationSettings } from "@/components/NotificationSettings";
import { useAPI } from "@/contexts/APIContext";
import { SettingsProvider, useSettings } from "@/contexts/SettingsContext";
import handleError from "@/utils/handleError";
import { useNavigate } from "react-router-dom";
import AvailabilityScheduleSettings from "./AvailabilityScheduleSettings";
import GoalSection from "./GoalSection";
import InterestsSection from "./InterestsSection";
import LanguagesSection from "./LanguagesSection";
import ProfileSection from "./ProfileSection";

function SettingsPageContent() {
  const { user, userProfile: profile, api, updateUser } = useAPI();
  const navigate = useNavigate();
  const { successMessage, errorMessage } = useSettings();

  const handleLogout = async () => {
    try {
      await api.deauthenticate();
      navigate("/login");
    } catch (err: any) {
      if (err.response?.status === 401) {
        navigate("/login");
        return;
      } else {
        handleError(err);
      }
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-white text-gray-800">
      <Header />

      <main className="flex flex-col gap-8 flex-1 max-w-screen-md mx-auto px-4 py-8 w-full">
        <div className="flex flex-row justify-between items-center">
          <h1 className="text-3xl font-bold">Settings</h1>
        </div>

        {successMessage && <div className="mb-6 p-3 bg-green-100 text-green-700 rounded-md">{successMessage}</div>}
        {errorMessage && <div className="mb-6 p-3 bg-red-100 text-red-700 rounded-md">{errorMessage}</div>}

        <div className="space-y-6">
          {/* Schedule Availability Section */}
          {user?.userId && <AvailabilityScheduleSettings userId={user.userId} api={api} updateUser={updateUser} />}

          <NotificationSettings />

          {/* Profile Section */}
          <ProfileSection profile={profile} />

          {/* Languages Section */}
          <LanguagesSection profile={profile} />

          {/* Daily Learning Goal Section */}
          <GoalSection initialGoal={user?.dailyGoal || "medium"} />

          {/* Interests Section */}
          <InterestsSection initialInterests={user?.interests || []} />
        </div>

        <button
          type="button"
          onClick={handleLogout}
          className="self-end bg-red-500 hover:bg-red-600 text-white py-2 px-6 rounded-full transition"
        >
          Logout
        </button>
      </main>

      <Footer />
    </div>
  );
}

function SettingsPage() {
  return (
    <SettingsProvider>
      <SettingsPageContent />
    </SettingsProvider>
  );
}

export default SettingsPage;
